import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here

import Localization from "../Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@material-ui/core';

class ReportBugDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
    };
    autoBind(this);
  }

  handleClose() {
    this.setState({
      open: false,
    });
    this.state.open = false;
  }

  handleSubmitClicked() {
    window.open("//forms.gle/9Jb4z1GjTNPnvLzm6");
    this.handleClose();
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'md'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.REPORT_BUG}
          </DialogTitle>
          <DialogContent>
            {Localization.strings.REPORT_BUG_MESSAGE}
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <Button onClick={this.handleClose}>{Localization.strings.CANCEL}</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={this.handleSubmitClicked}
            >
              {Localization.strings.OK}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default ReportBugDialog;
